import React from "react";
import { DistributorFilter } from "./FullHerirarchy";
import CompactCheckboxDropdown from "./CompactCheckboxDropdown";

interface DistributorFilterProps {
distributorFilter?:DistributorFilter
  filters: Record<string, string[]>;
  optionsMap: Record<string, { label: string; value: string }[]>;
  loadingMap: Record<string, boolean>;
  onFilterChange: (key: string, value: string | null) => void;
  onMultiFilterChange?: (key: string, values: string[]) => void;
  onLoadOptions: (fieldKey: string) => void;
  disabled?: boolean;
  disabledReason?: string;
  dropdownWidth?: number | string;
  searchText?: string;
  onSearchChange?: (value: string) => void;
  enableSelectAll?: boolean;
  selectAllLabel?: string;
}

const DistributorFilterNew: React.FC<DistributorFilterProps> = ({
distributorFilter,
  filters,
  optionsMap,
  loadingMap,
  onFilterChange,
  onMultiFilterChange,
  onLoadOptions,
  disabled = false,
  disabledReason,
  dropdownWidth,
  searchText,
  onSearchChange,
  enableSelectAll = false,
  selectAllLabel
}) => {
 

  const fieldKey = distributorFilter?.field??"";
  const options = optionsMap[fieldKey] || [];
  const selectedValues = filters[fieldKey] || [];

  const handleChange = (values: string[]) => {
    if (onMultiFilterChange) {
      onMultiFilterChange(fieldKey, values);
    }
  };

  const handleOpen = () => {
    // Load distributor options if not already loaded
    if (!disabled && (!options || options.length === 0)) {
      onLoadOptions(fieldKey);
    }
  };

  const handleClose = () => {
    // Clear search text when dropdown closes
    if (onSearchChange) {
      onSearchChange("");
    }
  };

  return (
    <div className="distributor-filter-wrapper">
      <CompactCheckboxDropdown
        label={
          <>
            {distributorFilter?.label??"Distributor levels"}
            <span style={{ color: 'red' }}>*</span>
          </>
        }
        options={options}
        selectedValues={selectedValues}
        onChange={handleChange}
        onOpen={handleOpen}
        loading={loadingMap[fieldKey] || false}
        disabled={disabled}
        placeholder="Distributor"
        width={dropdownWidth}
        dropdownWidth={250}
        searchText={searchText}
        onSearchChange={onSearchChange}
        enableSelectAll={enableSelectAll}
        selectAllLabel={selectAllLabel}
        onClose={handleClose}
      />
    </div>
  );
};

export default DistributorFilterNew;

